import React from 'react';

const ThemeWrapper = ({ theme = 'bloom-purple', children }) => {
    // Map theme names to their CSS classes
    const themeClass = `theme-${theme}`;

    return (
        <div className={`${themeClass} min-h-screen transition-colors duration-500`}>
            {children}
        </div>
    );
};

export default ThemeWrapper;
